module.exports = __webpack_public_path__ + "img/icon_weather_217.c1a6f7bc.svg";